import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import Files from 'react-files';
import {
  validateEmail,
  validatePhone,
  validateZip,
} from '../utils/form-validator';

const {
  i18n: {
    __,
  },
} = wp;

/**
 * ComplaintForm component.
 */
const ComplaintForm = (props) => {
  const {
    siteKey,
    agreeText,
    callLetters,
    nonce,
    stationName,
    isTelemundo,
  } = props;
  const fileInstructions = __('On a desktop computer? Hold “Ctrl" on PC or “command" on Mac to select multiple files. Up to 5 files will be accepted. Zip and all common image, video, and document formats are accepted. Any documents or images submitted could be used for broadcast or digital use.', 'nbc'); // eslint-disable-line max-len
  const [captchaSolved, setCaptchaSolved] = useState(false);
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [zip, setZip] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState([]);
  const validEmail = validateEmail(email);
  const validPhone = validatePhone(phone);
  const validZip = validateZip(zip);
  let numbersOnly = (phone.match(/\d/g) || []).join('');
  let newPhone = '';
  if ('' !== numbersOnly) {
    if ('1' !== numbersOnly.substring(0, 1)) {
      numbersOnly = `1${numbersOnly}`;
    }
    if (7 < numbersOnly.length) {
      newPhone = `+${numbersOnly.substring(0, 1)} (${numbersOnly.substring(1, 4)}) ${numbersOnly.substring(4, 7)}-${numbersOnly.substring(7, 11)}`; // eslint-disable-line max-len
    } else if (4 < numbersOnly.length) {
      newPhone = `+${numbersOnly.substring(0, 1)} (${numbersOnly.substring(1, 4)}) ${numbersOnly.substring(4, 7)}`; // eslint-disable-line max-len
    } else if (1 < numbersOnly.length) {
      newPhone = `+${numbersOnly.substring(0, 1)} (${numbersOnly.substring(1, 4)}`; // eslint-disable-line max-len
    } else if (1 === numbersOnly.length) {
      newPhone = `+${numbersOnly.substring(0, 1)}`;
    }
  }
  const valid = subject &&
    description &&
    firstName &&
    lastName &&
    validZip &&
    validEmail &&
    validPhone &&
    files &&
    captchaSolved;

  // Get EN station text.
  function getESStationText() {
    if ('KNBC' === callLetters) {
      return __('NBC4 I-Team', 'nbc');
    } else if ('WNBC' === callLetters) {
      return __('Better Get Baquero', 'nbc');
    }

    return `${stationName} Responds`;
  }

  function onSubmit(e) {
    if (! valid) {
      e.preventDefault();
      return false;
    }
    return true;
  }
  return (
    <Fragment key="formElement">
      <form
        action=""
        encType="multipart/form-data"
        method="post"
        onSubmit={onSubmit}
      >
        <div className="nf-form-fields-required">
          <span className="ninja-forms-req-symbol">*</span>
          {__('Required Fields', 'nbc')}
        </div>
        <label htmlFor="subject">
          {__('Type of Complaint', 'nbc')}
          <span className="ninja-forms-req-symbol">*</span>
        </label>
        <input
          id="subject"
          name="15"
          placeholder={__('Type of Complaint', 'nbc')}
          required="required"
          size="30"
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
        <label htmlFor="description">
          {__('Provide a detailed description of your problem', 'nbc')}
          <span className="ninja-forms-req-symbol">*</span>
        </label>
        <textarea
          cols="75"
          name="16"
          placeholder={__('Please type in complete sentences', 'nbc')}
          rows="4"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <div className="columns">
          <div className="column">
            <label htmlFor="first_name">
              {__('First name', 'nbc')}
              <span className="ninja-forms-req-symbol">*</span>
            </label>
            <input
              id="first_name"
              name="6"
              required="required"
              size="30"
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="column">
            <label htmlFor="last_name">
              {__('Last name', 'nbc')}
              <span className="ninja-forms-req-symbol">*</span>
            </label>
            <input
              id="last_name"
              name="7"
              required="required"
              size="30"
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
        </div>
        <div className="columns">
          <div className="column">
            <label htmlFor="zip">
              {__('Postal Code (only the first 5 digits)', 'nbc')}
              <span className="ninja-forms-req-symbol">*</span>
            </label>
            <input
              id="zip"
              name="14"
              placeholder={__('ex: 55555', 'nbc')}
              required="required"
              size="30"
              type="text"
              value={zip}
              onChange={(e) => setZip(e.target.value)}
              className={(! validZip && zip) ? 'invalid' : ''}
            />
          </div>
          <div className="column">
            <label htmlFor="email">
              {__('Email', 'nbc')}
              <span className="ninja-forms-req-symbol">*</span>
            </label>
            <input
              id="email"
              name="9"
              placeholder={__('ex: mailAdress@client.com', 'nbc')}
              required="required"
              size="30"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={(! validEmail && email) ? 'invalid' : ''}
            />
          </div>
        </div>
        <div className="columns">
          <div className="column">
            <label htmlFor="phone">
              {__('Phone number', 'nbc')}
              <span className="ninja-forms-req-symbol">*</span>
            </label>
            <input
              id="phone"
              name="8"
              placeholder={__('+1 (555)-555-5555)', 'nbc')}
              required="required"
              size="30"
              type="text"
              value={newPhone}
              onChange={(e) => setPhone(e.target.value)}
              className={(! validPhone && email) ? 'invalid' : ''}
            />
          </div>
        </div>
        <fieldset>

          <Files
            className="files-dropzone"
            name="files[]"
            onChange={setFiles}
            onError={setFileError}
            accepts={['audio/*', 'video/*', 'image/*', 'application/pdf', 'application/zip', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword']} // eslint-disable-line max-len
            multiple
            maxFiles={5}
            maxFileSize={10000000}
            minFileSize={0}
            clickable
          >
            <button className="inputfile_label" type="button">
              {__('Provide Documentation', 'nbc')}
              <span className="ninja-forms-req-symbol">*</span>
            </button>
          </Files>
          {fileError &&
            <p className="error">{(2 === fileError.code) ? __('File is too large', 'nbc') : fileError.message}</p> // eslint-disable-line max-len
          }
          <ul className="file_list">
            { 0 === files.length &&
              <li>{__('No file chosen', 'nbc')}</li>
            }
            {files.map((file) => (
              <li>{ file.name }</li>
            ))}
          </ul>

          <p>{fileInstructions}</p>

          <input type="hidden" name="22" value={callLetters} />
          <input type="hidden" name="45" value="online form" />
          <input type="hidden" name="tip_nonce" value={nonce} />
        </fieldset>
        <ReCAPTCHA
          sitekey={siteKey}
          onChange={setCaptchaSolved}
          className="recaptcha-container"
          hl={isTelemundo ? 'es' : 'en'}
        />
        <div className="agreetext">{agreeText}</div>

        { /* eslint-disable max-len */
          isTelemundo ?
            <Fragment>
              <p>El equipo de {stationName} Responde no proporcionará ayuda alguna en
                cierto tipo de conflictos. Por favor revise la siguiente lista del
                tipo de asuntos que {stationName} Responde NO AYUDA A RESOLVER:
              </p>
              <ul>
                <li>1. Asuntos de custodia o relacionados al derecho familiar</li>
                <li>2. Asuntos criminales</li>
                <li>3. Casos de personas fuera del área de cobertura
                  de nuestra señal
                </li>
                <li>4. Cualquier caso que actualmente esté pendiente en el tribunal,
                  o ante un juez, o que ya ha sido litigado/arbitrado
                </li>
                <li>5. Los casos en que ya estén involucrados abogados</li>
                <li>6. Casos de discriminación</li>
              </ul>
              <p>Tenga en cuenta que nuestros representantes no son abogados y no
                ofrecen asesoramiento jurídico. Mediante la comunicación con usted o
                por proporcionar ayuda, no nos estamos comprometiendo a actuar como
                su representante ni a asumir responsabilidades u obligaciones.
              </p>
              <p>No existe ninguna relación confidencial entre usted y cualquiera de
                nuestros representantes. La información que proporcione no será
                confidencial y ninguna información proporcionada será mantenida de
                forma segura.
              </p>
              <p>A pesar de que hacemos todo lo posible para asegurarnos de que
                nuestra información sea precisa y útil, no podemos garantizar que
                se llegará a una resolución. Además, {stationName} Responde no se hace
                responsable por cualquier pérdida o daño que pudiera sufrir como
                resultado de nuestra participación.  Usted acepta mantener al equipo
                de {stationName} Responde y a NBCU indemne de cualquier problema que
                pueda surgir relacionado a nuestra participación.
              </p>
            </Fragment> :
            <Fragment>
              <p>{getESStationText()} will not provide assistance with certain types of disputes. Please check the list below of cases that {getESStationText()} generally DOES NOT HELP RESOLVE:</p>
              <ol>
                <li>Any custody or family court matters.</li>
                <li>Any criminal matters.</li>
                <li> Matters from viewers/readers outside of our viewing area.</li>
                <li>Any case currently pending in court, or before a judge, or that has been litigated/arbitrated.</li>
                <li>Matters with attorneys involved.</li>
                <li>Discrimination claims.</li>
              </ol>
              <p>Keep in mind none of our representatives are lawyers and do not provide legal advice. By communicating with you or providing help, we are not committing to act as your representative or taking on any obligations.</p>
              <p>No confidential relationship exists between you and any of our representatives. The information you provide will not be kept confidential and will not be maintained in a secure manner.</p>
              <p>Although we go to great lengths to make sure our information is accurate and useful, we cannot guarantee a resolution. In addition, {getESStationText()} is not responsible for any loss or harm you might suffer as a result of our involvement. You agree to hold {getESStationText()} and NBCU harmless for any problems that may arise in connection with our involvement.</p>
            </Fragment>
          /* eslint-enable max-len */}

        <input
          type="submit"
          value={__('Send', 'nbc')}
          disabled={! valid}
        />
      </form>
    </Fragment>
  );
};

export default ComplaintForm;

ComplaintForm.propTypes = {
  siteKey: PropTypes.string.isRequired,
  agreeText: PropTypes.string.isRequired,
  callLetters: PropTypes.string.isRequired,
  nonce: PropTypes.string.isRequired,
  stationName: PropTypes.string.isRequired,
  isTelemundo: PropTypes.bool.isRequired,
};
